
@if(dailyStats() && globalStats()) {
  <div class="info-route">
    <app-box-1
      [padding]="16"
      [borderWidth]="1"
      [borderRadius]="16"
      [backgroundColor]="'#00000040'"
      [backdropFilterBlur]="24"
    >
      <section class="info-route__day-info">
        <div class="day-info__day">
          <span class="day__text">
            {{ 'Estás viendo' | translate }}
          </span>
          
          <span class="day__day">
            {{ 'Día' | translate }} {{ dailyStats().day }}
          </span>
        </div>
        
        <app-box-1
          [padding]="16"
          [borderWidth]="1"
          [borderRadius]="16"
          [backgroundColor]="'#00000040'"
          [backdropFilterBlur]="24"
        >
          <div class="day-info__day-month">
            <ci-icon 
              class="day-month__icon"
              name="calendar" 
              scale="1.5x"
            ></ci-icon>
            
            <div class="day-month__container">
              <span class="day-month__day">
                {{ getDateDailyRoute(dailyStats().date).day }}
              </span>
              <span class="day-month__month ci-paragraph-p1-regular">
                {{ getDateDailyRoute(dailyStats().date).month }}
              </span>
            </div>
          </div>
        </app-box-1>
        
        <app-box-1
          [padding]="16"
          [borderWidth]="1"
          [borderRadius]="16"
          [backgroundColor]="'#00000040'"
          [backdropFilterBlur]="24"
        >
          <div class="day-info__weather">
            <ci-icon 
              class="weather__icon"
              name="{{ dailyStats().weather.iconName }}" 
              scale="1.5x"
            ></ci-icon>
            
            <div class="weather__container">
              <span class="weather__degree">
                {{ dailyStats().weather.avgTemp }}°
              </span>
              <span class="weather__text ci-paragraph-p1-regular">
                {{ dailyStats().weather.status | translate }}
              </span>
            </div>
          </div>
        </app-box-1>
      </section>
    </app-box-1>

    @if(profiledRouteInfo()) {
      <app-box-1
        [padding]="16"
        [borderWidth]="1"
        [borderRadius]="16"
        [backgroundColor]="'#00000040'"
        [backdropFilterBlur]="24"
      >
        <section class="info-route__profile-info">
          <p class="profile-info__title">
            {{ 'Perfilado' | translate }}
          </p>
          
          <div class="profile-info__content">
            <div class="profile-inf__first-row">
              @if(profiledRouteInfo().traveler_type) {
                <app-box-1
                  [padding]="16"
                  [borderWidth]="1"
                  [borderRadius]="16"
                  [backgroundColor]="'#00000040'"
                  [backdropFilterBlur]="24"
                >
                  <div class="profile-info__traveller-type">
                    <p class="traveller-type__text">
                      {{ 'Tipo de viajero' | translate }}
                    </p>
                    
                    <ci-suggestion-chip-outline 
                      truncate
                      [attr.icon-name]="profiledRouteInfo().traveler_type.icon"
                    >
                      <span slot="label">
                        {{ profiledRouteInfo().traveler_type.name[selectedLanguage()] }}
                      </span>
                    </ci-suggestion-chip-outline>
                  </div>
                </app-box-1>
              }
            
              @if(profiledRouteInfo().origin) {
                <app-box-1
                  [padding]="16"
                  [borderWidth]="1"
                  [borderRadius]="16"
                  [backgroundColor]="'#00000040'"
                  [backdropFilterBlur]="24"
                >
                  <div class="profile-info__traveller-origin">
          
                      <p class="traveller-origin__text">
                        {{ 'Origen' | translate }}
                      </p>
                      
                      <ci-suggestion-chip-outline truncate>
                        <span slot="label">
                          {{ profiledRouteInfo().origin }}
                        </span>
                      </ci-suggestion-chip-outline>
                
                  </div>
                </app-box-1>
              }
            </div>
            
            @if(profiledRouteInfo().traveler_interests && profiledRouteInfo().traveler_interests.length > 0) {
              <app-box-1
                [padding]="16"
                [borderWidth]="1"
                [borderRadius]="16"
                [backgroundColor]="'#00000040'"
                [backdropFilterBlur]="24"
              >
                <div class="profile-info__interests">
                  <p class="interests__title">
                    {{ 'Intereses de viaje' | translate }}
                  </p>
                  
                  <ci-chip-set>
                    @for(interest of profiledRouteInfo().traveler_interests; track interest.id) {
                      <ci-suggestion-chip-outline 
                        [attr.icon-name]="interest.icon"
                        truncate
                      >
                        <span slot="label">
                          {{ interest.name[selectedLanguage()] }}
                        </span>
                      </ci-suggestion-chip-outline>
                    }
                  </ci-chip-set>
                </div>
              </app-box-1>
            }
          </div>
        </section>
      </app-box-1> 
    }
    
    <app-box-1
      [padding]="16"
      [borderWidth]="1"
      [borderRadius]="16"
      [backgroundColor]="'#00000040'"
      [backdropFilterBlur]="24"
    >
      <section class="info-route__transport-info">
        <p class="transport-info__title">
          {{ 'Transportes' | translate }}
        </p>
        
        <app-box-1
          [padding]="16"
          [borderWidth]="1"
          [borderRadius]="16"
          [backgroundColor]="'#00000040'"
          [backdropFilterBlur]="24"
        >
          <div class="transport-info__comparason">
            <p class="comparason__title">
              {{ 'Andando vs. transporte público' | translate }}
            </p>
            
            <app-angular-progress-bar
              [progress]="dailyPercentageWalkingVSTransport()"
            />
          </div>
        </app-box-1>
        
        <div class="transport-info__distances">
          <app-box-1
            [padding]="16"
            [borderWidth]="1"
            [borderRadius]="16"
            [backgroundColor]="'#00000040'"
            [backdropFilterBlur]="24"
          >
            <div class="transport-info__distance">
              <p class="distance__title">
                {{ 'Distancia andando' | translate }}
              </p>
              
              <span class="distance__distance">
                {{ dailyWalkingDistance().value }}
                <span class="distance__unit">
                  {{ dailyWalkingDistance().unit }}
                </span>
              </span>
            </div>
          </app-box-1>
          
          <app-box-1
            [padding]="16"
            [borderWidth]="1"
            [borderRadius]="16"
            [backgroundColor]="'#00000040'"
            [backdropFilterBlur]="24"
          >
            <div class="transport-info__distance">
              <p class="distance__title">
                {{ 'Distancia en transporte público' | translate }}
              </p>
              
              <span class="distance__distance">
                {{ dailyTransportDistance().value }}
                <span class="distance__unit">
                  {{ dailyTransportDistance().unit }}
                </span>
              </span>
            </div>
          </app-box-1>
        </div>
        
        <div class="transport-info__more">
          <app-box-1
            [padding]="16"
            [borderWidth]="1"
            [borderRadius]="16"
            [backgroundColor]="'#00000040'"
            [backdropFilterBlur]="24"
          >
            <div class="more__first-column">
              <p class="more__title">
                {{ 'Huella de Carbono generada' | translate }}
              </p>
              
              <span class="more__value">
                {{ carbonEmissions() }}
                <span class="value__unit">gr</span>
              </span>
            </div>
          </app-box-1>
          
          <app-box-1
            [padding]="16"
            [borderWidth]="1"
            [borderRadius]="16"
            [backgroundColor]="'#00000040'"
            [backdropFilterBlur]="24"
          >
            <div class="more__second-column">
              <p class="more__title">
                {{ 'Costo estimado' | translate }}
              </p>
              
              <span class="more__value">
                <span class="value__value">
                  {{ priceEstimation().value }}
                </span>
                <span class="value__unit">
                  {{ priceEstimation().unit }}
                </span>
              </span>
            </div>
          </app-box-1>
        </div>
      </section>
    </app-box-1>
  </div>
}
